/**
 * `<caos-inline-hint>` — explains what a field drives, worded for the surface it
 * appears on. (Catalog: Status & feedback › InlineHint — explains what a field drives, worded for the surface it appears on.)
 *
 * The project's single icon vocabulary is the info circle, shown ahead of muted
 * guidance text (the default slot). The SVG is inline (CSP-safe, no external
 * request) and inherits the accent via `currentColor`. `::part(hint)` / `::part(icon)`
 * are the styling seams.
 */
import { CaosElement, define, makeSheet } from '../base-element.js';
import { makeIcon } from './icons.js';

const sheet = makeSheet(`
  :host { display: block; }

  .hint {
    display: flex;
    align-items: flex-start;
    gap: var(--caos-space-2);
    font-family: var(--caos-font);
    font-size: 12px;
    line-height: 1.5;
    color: var(--caos-color-text-muted);
  }
  .icon {
    flex: none;
    width: 14px;
    height: 14px;
    margin-top: 1px;
    color: var(--caos-color-accent);
  }
  .icon svg { display: block; width: 100%; height: 100%; }
`);

export class CaosInlineHint extends CaosElement {
  constructor() {
    super(sheet);
    const hint = document.createElement('div');
    hint.className = 'hint';
    hint.setAttribute('part', 'hint');

    const icon = document.createElement('span');
    icon.className = 'icon';
    icon.setAttribute('part', 'icon');
    icon.setAttribute('aria-hidden', 'true');
    // CAOS-602 — the vocabulary's `info`, which this file had re-drawn circle for circle along
    // with a private copy of the element builder it needed to do it.
    icon.append(makeIcon('info'));

    const text = document.createElement('span');
    text.className = 'text';
    text.append(document.createElement('slot'));

    hint.append(icon, text);
    this.root.append(hint);
  }
}

define('caos-inline-hint', CaosInlineHint);

declare global {
  interface HTMLElementTagNameMap {
    'caos-inline-hint': CaosInlineHint;
  }
}
